import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { PACKAGE_NAME } from '@atlassian/jira-servicedesk-getting-started-panel-common/src/constants.tsx';
import { HasSeenReopenSpotlight } from '@atlassian/jsm-getting-started-panel';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { ActionProps, State } from '../../types.tsx';
import { savePanelState } from '../save-panel-state/index.tsx';

export type MarkReopenSpotlightAsSeen = () => Promise<void>;

export const markReopenSpotlightAsSeen =
	(actionProps: ActionProps) =>
	({ getState, dispatch }: StoreActionApi<State>): MarkReopenSpotlightAsSeen =>
	async () => {
		const { data } = getState();

		try {
			if (!data) {
				throw new Error('Trying to mark reopen spotlight as seen without current state');
			}

			await dispatch(savePanelState(actionProps))({
				...data,
				properties: {
					...data.properties,
					user: {
						...data.properties.user,
						hasSeenReopenSpotlight: HasSeenReopenSpotlight.Yes,
					},
				},
			});
			fireTrackAnalytics(
				actionProps.createAnalyticsEvent({}),
				`${PACKAGE_NAME}.markReopenSpotlightAsSeen succeeded`,
			);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'markReopenSpotlightAsSeen',
					packageName: PACKAGE_NAME,
					teamName: 'Sequoia',
				},
				sendToPrivacyUnsafeSplunk: true,
			});
			throw error;
		}
	};
